import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Button } from 'antd';

import * as S from './styles';

const NotFound: React.FC = () => {
  const { t } = useTranslation('main');

  return (
    <S.Container>
      <S.Content>
        <h1>{t('not-found.title')}</h1>
        <p>{t('not-found.description')}</p>
        <Button type="primary">
          <Link to="/">{t('not-found.button-text')}</Link>
        </Button>
      </S.Content>
    </S.Container>
  );
};

export default NotFound;
